import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Gallery from './components/Gallery';
import Admin from './components/Admin';
import ResetPassword from './components/ResetPassword';
import PlayerPage from './components/PlayerPage';
import About from './components/About';
import Contacts from './components/Contacts';
import HomePage from './components/HomePage';
import CommercialPage from './components/CommercialPage';
import UndergroundPage from './components/UndergroundPage';
import BookingPage from './components/BookingPage';

function AppContent({ currentTrack, isPlaying, tracks, onTrackSelect, onPlayPause, onTrackEnd, onNextTrack, onPreviousTrack }) {
  // Функция для обновления треков после загрузки в админ-панели
  const fetchTracks = async () => {
    // Обновление происходит автоматически через перезагрузку страницы
    // или можно добавить логику обновления здесь при необходимости
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route 
          path="/player" 
          element={
            <PlayerPage 
              currentTrack={currentTrack}
              isPlaying={isPlaying}
              tracks={tracks}
              onTrackSelect={onTrackSelect}
              onPlayPause={onPlayPause}
              onTrackEnd={onTrackEnd}
              onNextTrack={onNextTrack}
              onPreviousTrack={onPreviousTrack}
            />
          } 
        />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/commercial" element={<CommercialPage />} />
        <Route path="/underground" element={<UndergroundPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/admin" element={<Admin onTrackAdded={fetchTracks} />} />
        <Route path="/admin/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default AppContent;

